import { createApp } from 'vue'

window.rcb = window.rcb || {}

if (document.getElementById('concert-listing')) {
  const app = createApp({
    data() {
      return {
        concertDates: window.rcb.concertDates || [],
        filterSelections: {
          search: null,
          category: null,
          location: null,
        }
      }
    },
    computed: {
      /**
       * Group concert dates by year/month.
       */
      concertMonths() {
        let dates = this.concertDates.reduce((accumulator, currentValue) => {
          const concertDate = new Date(currentValue.timestamp * 1000)
          const monthString = concertDate.getFullYear() + '-' + (((parseInt(concertDate.getMonth()) + 1).toString()).padStart(2, '0'))

          accumulator[ monthString ] = accumulator[ monthString ] || {}

          accumulator[ monthString ].title = new Intl.DateTimeFormat('en-US', {month: 'long', year: 'numeric'}).format(concertDate)

          accumulator[ monthString ].concerts = accumulator[ monthString ].concerts || []
          accumulator[ monthString ].concerts.push(currentValue)

          return accumulator
        }, {})

        // Sort groups in ascending order.
        let groupedDates = Object.keys(dates).sort().reduce((result, key) => {
          result[key] = dates[key]
          return result
        }, {})

        // Filter the concerts.
        for (const group in groupedDates) {
          groupedDates[ group ].concerts = this.filterConcerts(groupedDates[ group ].concerts)
        }

        return groupedDates
      },
      concertCategories() {
        // Unique categories
        return this.concertDates.map(concert => concert.concertCategory.label).sort().filter((value, index, array) => {
          return array.indexOf(value) === index
        })
      },
      concertLocations() {
        // All locations
        let locations = this.concertDates.map(concert => {
          
          // If no category is selected, then do not include the "Touring" locations.
          if (
            ! this.filterSelections.category &&
            concert.concertCategory.value == 'touring'
          ) {
            return null
          }

          // If a category is selected, then only show the available locations.
          if (
            this.filterSelections.category &&
            concert.concertCategory.label != this.filterSelections.category
          ) {
            return null
          }

          return concert.location
        })

        // Unique locations
        return locations.sort().filter((value, index, array) => {
          return array.indexOf(value) === index
        })
      },
      totalFilteredConcerts() {
        let total = 0

        for (const group in this.concertMonths) {
          total += this.concertMonths[ group ].concerts.length
        }

        return total
      }
    },
    watch: {
      // Clear the location filter when the category filter is changed.
      'filterSelections.category'() {
        this.filterSelections.location = null
      }
    },
    methods: {
      setFilter(filter, selection) {
        if (this.filterSelections[filter] == selection) {
          this.filterSelections[filter] = null
        } else {
          this.filterSelections[filter] = selection
        }
      },
      filterConcerts(concerts) {
        let filtered = concerts.filter(concert => {

          // Category
          if (this.filterSelections.category) {
            if (concert.concertCategory.label != this.filterSelections.category) {
              return false
            }
          }

          // Location
          if (this.filterSelections.location) {
            if (concert.location != this.filterSelections.location) {
              return false
            }
          }

          return true
        })

        // Search
        if (this.filterSelections.search) {
          filtered = filtered.filter(concert => {
            if (
              (concert.concertTitle.toLowerCase().indexOf(this.filterSelections.search) > -1) || 
              (concert.location.toLowerCase().indexOf(this.filterSelections.search) > -1)
            ) {
              return true;
            }

            return false;
          })
        }

        return filtered
      }
    }
  })

  app.mount('#concert-listing')
}
